import React, { useEffect, useState } from 'react'
import SubTitle from '../Components/SubTitle';
import { useParams } from 'react-router-dom';
import { URL } from '../config';
import Loading from './Loading';
import axios from 'axios';
import ProductShow from '../Components/ProductShow';

const CategoryProducts = () => {
    const [titles,setTitles]=useState([]);
    const param=useParams();
    const CategoryId=param.CategoryId;
    const MainCategoryId=param.MainCategoryId;
    const MainCategoryName=param.MainCategoryName;
    const CategoryName=param.CategoryName;
    const [products,setProducts]=useState([]);
    const [nextPage,setNextPage]=useState('');
    const [path,setPath]=useState('');
    const [load,setLoad]=useState(false);
    useEffect(()=>{
        setTitles([{
           name:MainCategoryName,
            link:`/main_category/${MainCategoryId}/${MainCategoryName}` 
        },
            {
                name:CategoryName,
                link:``
            }
    ]);
        setLoad(true);
        axios.get(`${URL}/api/product/get_category_products/${CategoryId}`)
        .then(function (response) {
          if(response.data.success){
            setProducts(response.data.data.data);
            setNextPage(response.data.data.next_page_url);
            setPath(response.data.data.path);
          }
          setLoad(false);
            })
        .catch(function (error) {
          console.log('error');
          setLoad(false);
        });
      },[CategoryId])
if(load)
    return <Loading/>
  return (
    <div className='container-fluid mt-lg-5 pt-5 mb-2'>
    <SubTitle titles={titles}/>
    <ProductShow products={products} nextPage={nextPage} nextPath={path} titles={titles}/>
</div>
  )
}

export default CategoryProducts
